import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import { CartUpdateInput } from '@lib/graphql/graphql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { cartsQueryKeys } from '../query-keys'
import { getCartIdFromCookies } from '../utils'

const cartUpdateMutationDocument = graphql(`
  mutation CartUpdate($input: CartUpdateInput!) {
    cartUpdate(input: $input) {
      cart {
        ...CartDetail
      }
      errors {
        code: __typename
      }
    }
  }
`)

export const cartUpdateMutation = async (input: CartUpdateInput) => {
  return await execute(cartUpdateMutationDocument, { input })
}

export async function updateCart(input: Omit<CartUpdateInput, 'cartId'>) {
  const cartId = getCartIdFromCookies()

  return await cartUpdateMutation({
    cartId,
    ...input,
  })
}

export const useUpdateCart = (
  mutationConfig?: MutationConfig<typeof updateCart>,
) => {
  const queryClient = useQueryClient()
  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    mutationFn: updateCart,
    onSuccess: (data, variables, context) => {
      if (!data?.cartUpdate) {
        return
      }
      if (data?.cartUpdate?.errors) {
        return
      }
      queryClient.setQueryData(cartsQueryKeys.all, data.cartUpdate.cart)
      onSuccess?.(data, variables, context)
    },
    ...restConfig,
  })
}
